import React, { ReactNode } from "react";
import ModalLayout from "./ModalLayout";
import styled from "styled-components";
import PositiveIcon from "assets/common/modal/icon_modal_positive.svg";
import ErrorIcon from "assets/common/modal/icon_modal_error.svg";
import { device } from "components/styles";

// children: title, content가 아닌 모달 안 컨텐츠가 필요한 경우
// state: modal 상단 아이콘에 따라 positive, error, none으로 구별됨/ 기본값은 positive
// button: modal에 맞는 button 커스텀해서 사용 -> ModalButton 컴포넌트 사용/ button이 없는 modal일 경우 제외
interface DefaultModalProps {
  handlModalClose: () => void;
  children?: ReactNode;
  state?: "positive" | "error" | "none";
  title: string;
  content?: string;
  button?: ReactNode;
  customIcon?: string;
  isNoBg?: boolean;
  isOutsideClick?: boolean;
  isHtml?: boolean;
  customStyle?: React.CSSProperties;
}

const DefaultModal = ({
  handlModalClose,
  state = "positive",
  title,
  content,
  children,
  button,
  customIcon,
  isNoBg = false,
  isOutsideClick = true,
  isHtml = false,
  customStyle,
}: DefaultModalProps) => {
  const isPositive = state === "positive";

  return (
    <ModalLayout
      handleModalClose={handlModalClose}
      isNoBg={isNoBg}
      isOutsideClick={isOutsideClick}
    >
      <DefaultModalContainer style={customStyle}>
        <DefaultModalContentContainer>
          {state !== "none" && (
            <>
              {customIcon ? (
                <img src={customIcon} alt="modalIcon" className="modalIcon" />
              ) : (
                <img
                  src={isPositive ? PositiveIcon : ErrorIcon}
                  alt="modalIcon"
                  className="modalIcon"
                />
              )}
            </>
          )}
          <div className="textContainer">
            <div className="modalTitle">{title}</div>
            <div className="modalContent">
              {isHtml ? (
                <div
                  className="modal-content"
                  dangerouslySetInnerHTML={{ __html: content ?? "" }}
                />
              ) : (
                <div className="modal-content">{content}</div>
              )}
            </div>
          </div>
          {children}
        </DefaultModalContentContainer>

        <DefaultModalButtonContainer>{button}</DefaultModalButtonContainer>
      </DefaultModalContainer>
    </ModalLayout>
  );
};

export default DefaultModal;

const DefaultModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 1.2rem;
  background: #fff;
  width: 36rem;
  height: fit-content;
  box-sizing: border-box;

  .modalIcon {
    width: 4.5rem;
  }

  @media all and (${device.mobile}) {
    width: 32rem;

    .modalIcon {
      width: 4rem;
    }
  }
`;

const DefaultModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  align-items: center;
  width: 100%;
  padding: 3.6rem 2.4rem 2.4rem;
  box-sizing: border-box;

  @media all and (${device.mobile}) {
    padding: 2.4rem 2rem 2rem;
  }

  .textContainer {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    align-items: center;

    .modalTitle {
      color: #1c1d1f;
      font-size: 1.8rem;
      font-weight: 700;
      line-height: 150%;
    }

    .modalContent {
      color: #40444a;
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 150%;
      white-space: pre-wrap;
      text-align: center;
    }

    @media all and (${device.mobile}) {
      gap: 0.6rem;

      .modalTitle {
        font-size: 1.5rem;
        line-height: 2.4rem;
      }

      .modalContent {
        font-size: 1.5rem;
        line-height: 2.3rem;
      }
    }
  }
`;

const DefaultModalButtonContainer = styled.div`
  display: flex;
  width: 100%;
  border-top: 1px solid #e6eaee;
  box-sizing: border-box;
`;
